import { useEffect } from "react";

import classNames from "classnames/bind";
import DynamicPhoneNumber from "common/blocks/DynamicPhoneNumber";
import GoogleMapsEmbed from "common/blocks/GoogleMapsEmbed";
import dayjs from "utils/dayjs";

import Wrapper from "../common/Wrapper";
import styles from "./StoreDetails.module.scss";

const cx = classNames.bind(styles);

const formatDate = (date: Date) => dayjs(date).format("ddd DD/MM/YYYY");
const formatTime = (time: string, format: string) => dayjs(time, "HH:mm:ss").format(format);

const StoreDetails = ({ params }: any) => {
    const {
        onlineStoreData: { openingTimes: onlineOpeningTimes, isStoreOpen: isOnlineStoreOpen },
    } = params;
    const { geolocation, openingTimes, address } = params.storeData;
    const linesOpen = onlineOpeningTimes.find(({ date }: any) => dayjs(date).isToday());

    useEffect(() => {
        // Manually update infinity number
        window.setTimeout(() => {
            window._its?.("findAndReplaceNumbers");
        }, 0);
    });

    return (
        <div>
            <div className={cx("mapsWrapper")}>
                <GoogleMapsEmbed geolocation={`${geolocation.lat},${geolocation.lng}`} />
            </div>
            <Wrapper>
                <div className={cx("detailsWrapper")}>
                    <div className={cx("section")}>
                        <span className={cx("heading")}>Address</span>
                        <div className={cx("body")}>
                            <span>{address.line1}</span>
                            <span>{address.locality}</span>
                            <span>{address.postcode}</span>
                        </div>
                    </div>
                    <div className={cx("section")}>
                        <span className={cx("heading")}>Contact number</span>
                        <div className={cx("body")}>
                            {isOnlineStoreOpen ? (
                                <>
                                    <DynamicPhoneNumber isLink />
                                    <span>
                                        {`Lines open ${formatTime(
                                            linesOpen.openingTime,
                                            "HH:mm"
                                        )} until ${formatTime(linesOpen.closingTime, "HH:mm")}`}
                                    </span>
                                </>
                            ) : (
                                <span>Lines are currently closed</span>
                            )}
                        </div>
                    </div>
                    <div className={cx("section")}>
                        <span className={cx("heading")}>Opening times</span>
                        <ul className={cx("body", "list")}>
                            {openingTimes.map((time: any) => {
                                return (
                                    <li key={time.date} className={cx("item")}>
                                        <span>{formatDate(time.date)}</span>
                                        <span>
                                            {time.isOpen &&
                                            time.openingTime !== time.closingTime ? (
                                                `${formatTime(
                                                    time.openingTime,
                                                    "h:mm A"
                                                )} - ${formatTime(time.closingTime, "h:mm A")}`
                                            ) : (
                                                <span className={cx("closed")}>Closed</span>
                                            )}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </Wrapper>
        </div>
    );
};

export default StoreDetails;
